// @flow
import React from 'react'
import styled from 'styled-components'
import {observer} from 'mobx-react'
import GridLayout from 'components/GridLayout'
import type {GridName} from '../entities'
import gridStore from 'stores/grid'

type Props = {|
  match: { params: { gridName: GridName }},
  history: {push:(path:string)=> void}
|}

type State = {
  key: number
}

export default observer(class Grid extends React.Component<Props,State> {

  state = {key:0}

  componentDidMount(){
    window.__lastLocation = window.location.pathname
  }

  componentDidCatch(){
    this.props.history.push('/')
    // this.setState({key:this.state.key+1})
  }

  render(){
    const {gridName} = this.props.match.params
    const innerGrid = gridStore[gridName]
    const push = this.props.history.push
    return (
      <Wrapper>
        <GridLayout 
          key={gridName+this.state.key} 
          grid={innerGrid.formattedGrid} 
          onGridChange={innerGrid.updateFormattedGrid}
          push={push}
          gridName={gridName}
          refresh={() => this.setState({key:this.state.key+1})}
        />
      </Wrapper>
    )
  }
})

const Wrapper = styled.div``

// https://app.contentful.com/spaces/qrma0jgw0rvs/environments/staging/entries?access_token=ad7f0dc479378057e3ce854049ea8660c102a1fd6ad3e6599817eefa29b26c70&sys.id=2qesfMpbB2S4I0OOsQKaGa


// WEBPACK FOOTER //
// ./src/routes/Grid.js